var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAclActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 2.5C20.8284 2.5 21.5 3.17157 21.5 4V20C21.5 20.8284 20.8284 21.5 20 21.5H4C3.17157 21.5 2.5 20.8284 2.5 20V4C2.5 3.17157 3.17157 2.5 4 2.5H20ZM7.75 4H4V20H7.75V4ZM9.25 4V20H20V4H9.25Z",
    fill: "#E6E7EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9001 6.25C17.3143 6.25 17.6501 6.58579 17.6501 7C17.6501 7.3797 17.3679 7.69349 17.0019 7.74315L16.9001 7.75H12.1001C11.6859 7.75 11.3501 7.41421 11.3501 7C11.3501 6.6203 11.6323 6.30651 11.9983 6.25685L12.1001 6.25H16.9001ZM16.9001 13.25C17.3143 13.25 17.6501 13.5858 17.6501 14C17.6501 14.3797 17.3679 14.6935 17.0019 14.7432L16.9001 14.75H12.1001C11.6859 14.75 11.3501 14.4142 11.3501 14C11.3501 13.6203 11.6323 13.3065 11.9983 13.2568L12.1001 13.25H16.9001ZM17.6501 10.5C17.6501 10.0858 17.3143 9.75 16.9001 9.75H12.1001L11.9983 9.75685C11.6323 9.80651 11.3501 10.1203 11.3501 10.5C11.3501 10.9142 11.6859 11.25 12.1001 11.25H16.9001L17.0019 11.2432C17.3679 11.1935 17.6501 10.8797 17.6501 10.5Z",
    fill: "#3BC2C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAclActive);
export default __webpack_public_path__ + "static/media/aclActive.518da72fc26f366ad4c75c8bc6b9b7fc.svg";
export { ForwardRef as ReactComponent };